import ExperimentDtoClient from 'business/models/ExperimentDtoClient';

export const fontFamilies: any[] = [
  { key: 'Inter', name: 'Inter' },
  { key: 'Lato', name: 'Lato' },
  { key: 'Lora', name: 'Lora' },
  { key: 'OpenSans', name: 'Open Sans' },
  { key: 'PTSerif', name: 'PT Serif' },
  { key: 'Roboto', name: 'Roboto' },
  { key: 'RobotoMono', name: 'Roboto Mono' },
];

export const fontStyles: string[] = ['Regular', 'Bold', 'Italic', 'Bold Italic'];

const fontUrl = (dir: string, file: string) =>
  `${window.location.origin}/fonts/${dir}/${file}`;

export const fonts = {
  Inter: {
    normal: fontUrl('inter', 'Inter-Regular.ttf'),
    bold: fontUrl('inter', 'Inter-Bold.ttf'),
    italics: fontUrl('inter', 'Inter-Italic.ttf'),
    bolditalics: fontUrl('inter', 'Inter-BoldItalic.ttf'),
  },
  Lato: {
    normal: fontUrl('lato', 'Lato-Regular.ttf'),
    bold: fontUrl('lato', 'Lato-Bold.ttf'),
    italics: fontUrl('lato', 'Lato-Italic.ttf'),
    bolditalics: fontUrl('lato', 'Lato-BoldItalic.ttf'),
  },
  Lora: {
    normal: fontUrl('lora', 'Lora-Regular.ttf'),
    bold: fontUrl('lora', 'Lora-Bold.ttf'),
    italics: fontUrl('lora', 'Lora-Italic.ttf'),
    bolditalics: fontUrl('lora', 'Lora-BoldItalic.ttf'),
  },
  OpenSans: {
    normal: fontUrl('open-sans', 'OpenSans-Regular.ttf'),
    bold: fontUrl('open-sans', 'OpenSans-Bold.ttf'),
    italics: fontUrl('open-sans', 'OpenSans-Italic.ttf'),
    bolditalics: fontUrl('open-sans', 'OpenSans-BoldItalic.ttf'),
  },
  PTSerif: {
    normal: fontUrl('pt-serif', 'PTSerif-Regular.ttf'),
    bold: fontUrl('pt-serif', 'PTSerif-Bold.ttf'),
    italics: fontUrl('pt-serif', 'PTSerif-Italic.ttf'),
    bolditalics: fontUrl('pt-serif', 'PTSerif-BoldItalic.ttf'),
  },
  Roboto: {
    normal: fontUrl('roboto', 'Roboto-Regular.ttf'),
    bold: fontUrl('roboto', 'Roboto-Bold.ttf'),
    italics: fontUrl('roboto', 'Roboto-Italic.ttf'),
    bolditalics: fontUrl('roboto', 'Roboto-BoldItalic.ttf'),
  },
  RobotoMono: {
    normal: fontUrl('roboto-mono', 'RobotoMono-Regular.ttf'),
    bold: fontUrl('roboto-mono', 'RobotoMono-Bold.ttf'),
    italics: fontUrl('roboto-mono', 'RobotoMono-Italic.ttf'),
    bolditalics: fontUrl('roboto-mono', 'RobotoMono-BoldItalic.ttf'),
  },
};

const FONT_VARIANT_DESCRIPTORS = {
  normal: { weight: 'normal', style: 'normal' },
  bold: { weight: 'bold', style: 'normal' },
  italics: { weight: 'normal', style: 'italic' },
  bolditalics: { weight: 'bold', style: 'italic' },
};

const PUBLIC_FONT_KEYS = ['Inter', 'Lato', 'Lora', 'OpenSans', 'PTSerif'];

export const registerPublicFonts = () => {
  PUBLIC_FONT_KEYS.forEach((key) => {
    const family = fontFamilies.find((f) => f.key === key);
    const variants = fonts[key];
    Object.entries(variants).forEach(([variant, url]) => {
      const descriptor = FONT_VARIANT_DESCRIPTORS[variant];
      document.fonts.add(new FontFace(family.name, `url(${url})`, descriptor));
    });
  });
};

export type CaptureProfileOption = {
  id: number;
  name?: string;
  selected: boolean;
};

export type IngredientReportOptionProps = {
  docData: ExperimentDtoClient;
  canvasRef: any;
  platePadding: number;
  selectedWells: any;
};

export type IngredientReportOptionsDTO = {
  dropNumber: string;
  fitToPage: boolean;
  rowLimit: number;
  columnLimit: number;
  maxIngredients: number;
  showProteinName: boolean;
  showFragmentName: boolean;
  showSeedName: boolean;
  showAdditiveName: boolean;
  showDropVolumes: boolean;
  showWellVolumes: boolean;
  showColumnNameHeading: boolean;
  concentration: boolean;
  pH: boolean;
  pHVolumes: boolean;
  ingredientNamePreference: string;
  drops: any[];
  fontFamily: any;
  fontStyle: string;
  fontSize?: number;
  isScreenExperiment: boolean;
};

export const blankImage =
  'data:image/jpeg;base64,/9j/4QAiRXhpZgAASUkqAAgAAAABAJiCAgAAAAAAAAAAAAAAAAD/4QAC/9sAhAAGBAQEBQQGBQUGCQYFBgkLCAYGCAsMCgoLCgoMEAwMDAwMDBAMDg8QDw4MExMUFBMTHBsbGxwfHx8fHx8fHx8fAQcHBw0MDRgQEBgaFREVGh8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx//wgARCAGaAmcDAREAAhEBAxEB/8QAJwABAQAAAAAAAAAAAAAAAAAAAAgBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAKpAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB//EABQQAQAAAAAAAAAAAAAAAAAAALD/2gAIAQEAAT8Aek//xAAUEQEAAAAAAAAAAAAAAAAAAACw/9oACAECAQE/AHpP/8QAFBEBAAAAAAAAAAAAAAAAAAAAsP/aAAgBAwEBPwB6T//Z';

export const maxReportNumberDecimalPlaces = 3;

export const enum ReportSnackbarText {
  PREPARING = 'Preparing',
  LOADING = 'Loading',
}

export const pageSize = {
  a4: {
    width: 595.28,
    height: 841.89,
  },
};

export const BATCH_SIZE = 300;
